/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./forum.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./forum.component";
import * as i3 from "../data/process.service";
import * as i4 from "../util/location.service";
var styles_ForumComponent = [i0.styles];
var RenderType_ForumComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ForumComponent, data: {} });
export { RenderType_ForumComponent as RenderType_ForumComponent };
export function View_ForumComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [["class", "p-3"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" Redirecting to the forum\n"]))], null, null); }
export function View_ForumComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-forum", [], null, null, null, View_ForumComponent_0, RenderType_ForumComponent)), i1.ɵdid(1, 114688, null, 0, i2.ForumComponent, [i3.ProcessService, i4.LocationService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ForumComponentNgFactory = i1.ɵccf("app-forum", i2.ForumComponent, View_ForumComponent_Host_0, {}, {}, []);
export { ForumComponentNgFactory as ForumComponentNgFactory };
